import isApiError from "@insite/client-framework/Common/isApiError";
import { fetch } from "@insite/client-framework/ServerSideRendering";
import { ApiError, ApiParameter, get, rawRequest, request } from "@insite/client-framework/Services/ApiService";

export interface GeneratePdfResultModel {
    result: any;
}

export interface GeneratePdfParameter extends ApiParameter {
    identifier?: string;
    templateName?:string;
    showMsrp?:boolean;
    notes?:string;
    brandName?: string;
    CollectionName?: string;
}

export const GeneratePdfUrl = "/api/v2/generatepdf";

export async function GeneratePdf(parameter: GeneratePdfParameter) {
    const request ={
        identifier: parameter.identifier,
        templateName: parameter.templateName,
        showMsrp: parameter.showMsrp,
        notes: parameter.notes,
    };

    const response = await fetch(`${GeneratePdfUrl}`,{
        method : "POST",
        headers: {
            "Content-Type": "application/json",
            // 'Content-Type': 'application/x-www-form-urlencoded',
          },
        body: JSON.stringify(request)
    });

    try {
        const blob = response.ok && (await response.blob());
        if (!response.ok) {
            throw new Error(
                JSON.stringify({
                    status: response.status,
                    errorJson: {
                        message: response.statusText,
                    },
                }),
            );
        }
        return blob;
    } catch (error) {
        let message: string;
        let errorJson: any;
        if (response.headers.get("Content-Type")?.startsWith("application/json")) {
            errorJson = (await response.json()) as { message: string; exceptionMessage?: string };
            message = errorJson.exceptionMessage ?? errorJson.message;
        } else {
            message = await response.text();
        }
        throw new ApiError(GeneratePdfUrl, response, message, errorJson);
    }
}
